<template>
    <FormSelect
        v-bind="$attrs"
        :label="label"
        @input="$emit('input', $event)"
        :required="required"
    >
        <option v-for="state in usaStates" :key="state" :value="state">{{ state }}</option>
    </FormSelect>
</template>


<script>
import UsaStates from 'usa-states';

const usaStates = new UsaStates.UsaStates().states.map(state => state.name);

export default {
    name: 'FormSelectState',
    inheritAttrs: false,

    props: {
        label: { type: String, default: 'State' },
        required: { type: Boolean, default: false },
    },

    data: () => ({ usaStates }),
};
</script>
